import React from 'react'

import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import getScoreColor from './getScoreColor'

const OPTIONS = [
  { value: 1, label: 'Rare' },
  { value: 2, label: 'Unlikely' },
  { value: 3, label: 'Possible' },
  { value: 4, label: 'Likely' },
  { value: 5, label: 'Almost Certain' },
]

const LikelihoodSelector = ({ value, onChange, label, required, size }) => (
  <FormControl fullWidth size={size}>
    <InputLabel id={`${label}-label`}>{label}</InputLabel>
    <Select
      labelId={`${label}-label`}
      value={value}
      label={label}
      onChange={onChange}
      required={required}
    >
      {OPTIONS.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          <Box display="flex" alignItems="center" gap={1}>
            <Box
              aria-hidden="true"
              sx={{
                width: 9,
                height: 9,
                borderRadius: '50%',
                bgcolor: getScoreColor(option.value),
                flexShrink: 0,
              }}
            />
            <Typography>
              {option.value} &mdash; {option.label}
            </Typography>
          </Box>
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)

export default LikelihoodSelector
